<template>
    <div>
        <section class="section-padding dark-bg">
            <div class="container">
                <h2 class="text-center text-white">
                    Vende o Permuta
                    <span>Tu Vehículo Usado</span>
                </h2>
                <h3 class="text-center mb-0 text-white">
                    <span>
                        Nos encargamos de la venta de tu vehículo desde el
                        principio hasta el final, maximizando el valor comercial
                        del vehículo, garantizando el pago y el traspaso.
                    </span>
                </h3>
            </div>
        </section>
        <section id="services" class="section-padding">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <headerAsistente />
                        <marcaForm v-if="asistenteStepData == ''" />
                        <modeloForm v-if="asistenteStepData == 'modelo'" />
                        <lineaForm v-if="asistenteStepData == 'linea'" />
                        <versionForm v-if="asistenteStepData == 'version'" />
                        <colorForm v-if="asistenteStepData == 'color'" />
                        <kmForm v-if="asistenteStepData == 'kilometraje'" />
                        <datosForm v-if="asistenteStepData == 'datos'" />
                        <avaluoForm v-if="asistenteStepData == 'avaluo'" />
                    </div>
                </div>
            </div>
        </section>
        <section class="section-padding gray-bg" id="consignar">
            <div class="container">
                <div class="section-header">
                    <div class="row">
                        <div class="col-md-8 mt-5">
                            <h4>
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Diligencia los datos de tu vehículo en unos
                                    simples clics.
                                </span>
                                <hr />
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Agenda una inspección a domicilio o en
                                    nuestra sede.
                                </span>
                                <hr />
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Vende tu vehículo al mejor precio del
                                    mercado.
                                </span>
                            </h4>
                            <b-row>
                                <div class="col-md-6 text-center ">
                                    <div class="form-group">
                                        <a
                                            href="#services"
                                            class="btn btn-block text-uppercase mt-5"
                                        >
                                            Cotiza tu vehículo
                                            <span class="angle_arrow"
                                                ><i
                                                    class="fa fa-angle-right"
                                                    aria-hidden="true"
                                                ></i
                                            ></span>
                                        </a>
                                    </div>
                                </div>
                            </b-row>
                        </div>
                        <div class="col-md-4">
                            <div class="row mt-3">
                                <div class="col-md-12 text-center ">
                                    <img
                                        src="/assets/images/slider/carros.png"
                                        alt="image"
                                        class="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import headerAsistente from "./asistente/headerAsistente";
//import formVender from "./frontFormVender";
import marcaForm from "./asistente/marcaForm";
import modeloForm from "./asistente/modeloForm";
import lineaForm from "./asistente/lineaForm";
import versionForm from "./asistente/versionForm";
import colorForm from "./asistente/colorForm";
import kmForm from "./asistente/kmForm";
import datosForm from "./asistente/datosForm";
import avaluoForm from "./asistente/avaluoForm";
import helper from "helpers/main-helper";
export default {
    props: ["get_marcas", "consignacion"],
    mounted() {
        var path = window.location.pathname;
        if (path === "/vender/response") {
            var consignacion_data = this.consignacion;
            var estado = consignacion_data.estado_principal.slug;
            this.titulo_span =
                "Este es el resultado del avalúo comercial del vehículo";
            this.asistente_step = "avaluo";
            if (estado === "avaluo") {
                this.velocimetro = true;
                var cotizacion = consignacion_data.proceso.avaluo.cotizacion;
                this.cotizacion = {
                    ...this.cotizacion,
                    ...cotizacion
                };
                this.marca_name = consignacion_data.vehiculo.marca;
                this.linea_name = consignacion_data.vehiculo.linea;
                this.version_name = consignacion_data.vehiculo.version;
                this.modelo = consignacion_data.vehiculo.modelo;
                this.kilometraje = consignacion_data.vehiculo.kilometraje;
            } else {
                this.pendiente = true;
            }
        } else {
            this.parse_marcas();
        }
    },
    components: {
        headerAsistente,
        marcaForm,
        modeloForm,
        lineaForm,
        versionForm,
        colorForm,
        kmForm,
        datosForm,
        avaluoForm
    },
    computed: {
        ...mapFields("vender", [
            "form_data.marcas",
            "velocimetro",
            "pendiente",
            "cotizacion",
            "asistente_step",
            "titulo_span",
            "selection_data.marca_name",
            "selection_data.linea_name",
            "selection_data.version_name",
            "selection_data.modelo",
            "selection_data.kilometraje"
        ]),
        asistenteStepData() {
            return this.$store.state.vender.asistente_step;
        }
    },
    methods: {
        parse_marcas() {
            var parsingMarcas = JSON.parse(this.get_marcas);
            var getMarcas = parsingMarcas.marcas;
            this.marcas = _.orderBy(getMarcas, ["name"], ["asc"]);
        }
    }
};
</script>
<style lang="scss">
.input-group-text {
    background-color: #e9ecef;
    border: 1px solid #e9ecef;
}
button#button-models {
    color: #6c757d !important;
    background: #ebeff3 !important;
    font-weight: 500;
    margin-bottom: 1rem;
    padding: 1px 10px;
}
</style>
